import { asyncLoader } from './core/AsyncLoader'
import { scrollListener } from './core/ScrollListener'
import { websiteService } from './service/WebsiteService'
import { newsWrapper } from './wrapper/NewsWrapper'
import { loaderComponent } from './components/LoaderComponent'

window.addEventListener('DOMContentLoaded', async () => {
	const NUMBER_OF_LOAD_POSTS_PER_QUERY = 6
	const GROUP_AND_WRAP_POST_PER = false
	const newsContainer = document.querySelector('#product-post-container')
	const loaderContainer = document.querySelector('#product-loader-container')
	const metaBaseUrl = document.querySelector('[data-base-url]')
	const baseUrl = metaBaseUrl.dataset.baseUrl

	scrollListener.setContainer(newsContainer)
	loaderComponent.setContainer(loaderContainer)

	newsWrapper
		.setContainer(newsContainer)
		.setPostsPerGroup(GROUP_AND_WRAP_POST_PER)

	websiteService
		.setBaseUrl(baseUrl)
		.setCounter(NUMBER_OF_LOAD_POSTS_PER_QUERY)

	await asyncLoader
		.setWebsiteService(websiteService)
		.loadMorePosts()

	scrollListener.addListener()
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_news_loader/script.js